import { render, staticRenderFns } from "./NavDrawerItems.vue?vue&type=template&id=6207b69c&"
import script from "./NavDrawerItems.vue?vue&type=script&lang=js&"
export * from "./NavDrawerItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports